module.exports = __webpack_public_path__ + "img/logo.e53cce4d.png";